import styles from '../shared.module.scss'

export default {
  root: {
    color: styles['color__black'],
    display: 'inline-block',
    //width: styles['field__width'],
  },
}
